import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'bkg-banner',
  template: `
    <div
      *ngIf="isVisible"
      [class.banner--error]="isErrorBanner"
      [class.banner--warning]="isWarningBanner"
      class="banner"
    >
      <div class="container">
        <div class="banner__content">
          <span> {{ message }} </span>
        </div>
        <button class="banner__close" (click)="onCloseBanner()">
          <img [src]="'assets/images/icons/close-inverse.svg'" />
        </button>
      </div>
    </div>
  `,
})
export class BannerComponent {
  @Input() isVisible: boolean;
  @Input() message: string;
  @Input() isErrorBanner: boolean;
  @Input() isWarningBanner: boolean;

  @Output() closeBanner = new EventEmitter<void>();

  onCloseBanner(): void {
    this.closeBanner.emit();
  }
}
